import React, { useEffect, useState } from 'react'
import { Select } from 'antd'
import _ from 'lodash'
import { AnswerType } from '../../Show'

type Contact = {
  email: string
  name?: string
  id: number
  version?: number | undefined
}

type Props = {
  cc: string[]
  setCc: (cc: string[]) => void
  lastAnswer: AnswerType | null
  contacts: Contact[]
}

const { Option } = Select

const SelectCC: React.FC<Props> = ({ cc, setCc, lastAnswer, contacts }) => {
  const [contactOptions, setContactOptions] = useState<Contact[]>([])

  const setData = () => {
    if (lastAnswer) {
      setContactOptions(
        _.uniqBy([...lastAnswer.cc, ...contacts], obj => obj.email)
      )
      setCc(lastAnswer.cc.map(item => item.email))
    } else {
      setContactOptions(contacts)
    }
  }

  useEffect(() => {
    setData()
  }, [lastAnswer])

  const handleChange = value => {
    setCc(value)
  }

  return (
    <>
      <span className="ticket-show-editor__cc-label">cc:</span>
      <Select
        className="ticket-show-editor__cc-select"
        mode="multiple"
        // placeholder={intl.formatMessage({ id: 'ticket / cc / placeholder' })}
        onChange={handleChange}
        size="small"
        allowClear={true}
        value={cc}
      >
        {contactOptions.map((contact, index) => (
          <Option key={index} value={contact.email}>
            {contact.email}
          </Option>
        ))}
      </Select>
    </>
  )
}

export default SelectCC
